<template>
  <div class="border-radius recent-pages__item recent-pages__item-unpublish bg-light-grey-600" :class="{ 'default-page': isDefault() }">
    <div class="recent-pages__row d-flex align-items-center justify-content-between">
      <div class="d-flex flex-grow-1">
        <div class="recent-pages__img mr-2">
          <img v-if="isOriginalShopifyPage || page.isGpTemplate == false || page.gp_unlink == true" :src="require('@/core/assets/Shopify.jpg')" />
          <img v-else-if="page.thumbnailUrl && page.thumbnailUrl > ''" :src="thumbnail" />
          <img v-else :src="require('@/core/assets/ThumbnailPlaceholder.jpg')" />
        </div>
        <div class="d-flex flex-column align-items-start justify-content-center">
          <!-- heading -->
          <div class="d-flex align-items-center recent-pages__heading">
            <div class="d-flex align-items-center recent-pages__title mr-1">
              <span class="heading-h6-14-medium text-light-high content" ref="title" @mouseenter="titleTooltip = true" @mouseleave="titleTooltip = false">
                {{ titlePage }}
              </span>
            </div>
            <div class="recent-pages__status mr-1" :class="pageStatusClass" v-if="pageStatus">
              <p class="recent-pages__status-text typo-paragraph12 typo-medium">{{ pageStatus }}</p>
            </div>
            <div v-if="isRunningAbTesting" class="recent-pages__status campaign" @mouseenter="campaignTooltip = true" @mouseleave="campaignTooltip = false">
              <div v-if="campaignTooltip" class="tool-tip tool-tip-campaign d-flex align-items-center">
                <span class="tool-tip-value typo-regular">{{ $t("page.campaign.tooltip") }}</span>
              </div>
              <p class="typo-paragraph12 typo-medium">{{ $t("page.status.campaign") }}</p>
            </div>
            <div v-else-if="isPublishScheduled && ['Product Page', 'Collection Page', 'Home Page'].includes(pageType[page.type])" class="recent-pages__status schedule">
              <p class="typo-paragraph12 typo-medium">{{ $t("page.status.scheduled") }}</p>
            </div>
            <div v-else-if="!page.is_published && !isOriginalShopifyPage && ['Product Page', 'Collection Page', 'Home Page'].includes(pageType[page.type])" class="recent-pages__status draft">
              <p class="typo-paragraph12 typo-medium">{{ $t("page.status.draft") }}</p>
            </div>
          </div>

          <div class="d-flex align-items-center mt-1">
            <span v-if="currentPageType == 'productpages'" class="body-12-regular text-dark6">{{ assignmentCount }}</span>
            <span v-if="currentPageType == 'productpages'" class="recent-pages__seperator"></span>

            <!-- Scheduled Published at -->
            <div class="recent-pages__schedule-publish d-flex align-items-center" v-if="isPublishScheduled">
              <p class="recent-pages__schedule-publish-at body-12-regular text-dark6">{{ schedulePublishAt }}</p>
            </div>

            <!-- Modified at -->
            <div class="recent-pages__modified d-flex align-items-center" v-if="isModifiedAt">
              <p class="recent-pages__modified-at body-12-regular text-ligh-low text-dark6 d-flex" v-if="!isOriginalShopifyPage">{{ $t("page.sort.modified") }} {{ lastModfiedTime }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end align-items-center flex-shrink-1 mr-1">
        <a :href="isOpenViewLive && page.viewliveUrl" target="_blank" class="page-item-tools-viewlive-button">
          <div class="recent-pages__action-view-live d-flex align-items-center justify-content-center mr-1" v-popover:tooltip.bottom="$t('generals.viewLivePage')" v-if="showViewLiveCondition">
            <i class="icon icon-view typo-icon-20 text-dark6"></i>
          </div>
        </a>
        <div class="unpublish-card__checkbox">
          <label class="unpublish-card__checkbox-item" :class="[{ checked: isSelected }, { 'unchecked-disabled': isDisabledSelect }]">
            <i class="icon icon-selected text-light1"></i>
            <input type="checkbox" @click="selectPage()" />
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TimeMaker } from "@/plugins";
import { mapGetters, mapState, mapMutations } from "vuex";
import { mutations } from "@/store/downgrade/types";

export default {
  name: "TemplateCard",

  props: {
    page: {
      type: [Object, Boolean]
    },
    currentPageType: String
  },
  data() {
    return {
      titleTooltip: false,
      campaignTooltip: false,
      campaignDescTooltip: false,
      flagFullEvents: false,
      loading: true
    };
  },
  computed: {
    ...mapGetters("account", {
      language: "displayLanguage"
    }),
    ...mapGetters("page", {
      getAssignItems: "getAssignItems"
    }),
    ...mapState("page", {
      assignProductList: state => state.assignments.productpages.list,
      isAssignAllProducts: state => state.assignments.productpages.isAssignAll
    }),
    ...mapState("account", {
      permissions: "permissions"
    }),
    ...mapState("downgrade", {
      productList: state => state.pages["productpages"].unpublishList,
      articleList: state => state.pages["articlepages"].unpublishList
    }),
    isRunningAbTesting() {
      return this.page.runningCampaignId > 0;
    },
    textDefault() {
      return {
        "Theme Product Template": this.$t("page.defaultShopifyTemplate"),
        "Theme Collection Template": this.$t("page.defaultShopifyTemplate"),
        "Theme Index Template": this.$t("page.defaultShopifyTemplate"),
        "Your first Homepage": this.$t("page.defaultShopifyTemplate")
      };
    },
    pageType() {
      return {
        "template-page": this.$t("page.landingPages1"),
        "template-index": this.$t("dashboard.homePage"),
        "template-product": this.$t("dashboard.productPage"),
        "template-collection": this.$t("dashboard.collectionPage"),
        "template-article": this.$t("dashboard.articlePage")
      };
    },
    isOpenViewLive() {
      if (["Blog Post"].includes(this.pageType[this.page.type])) {
        if (!this.page.is_published) return false;
      }
      if (this.page && this.page.viewliveUrl) return true;
      return false;
    },
    showViewLiveCondition() {
      if (!this.page.viewliveUrl) return false;
      if (["Blog Post"].includes(this.pageType[this.page.type])) {
        return this.page.is_published;
      }
      return !["Product Page"].includes(this.pageType[this.page.type]);
    },
    isEllipsisTitleActive() {
      if (!this.$refs.title) return;
      return this.$refs.title.offsetWidth < this.$refs.title.scrollWidth;
    },
    pageStatusClass() {
      if (["Product Page", "Collection Page", "Home Page"].includes(this.pageType[this.page.type])) {
        if (this.isDefault()) return "default";
        return;
      }
      if (this.isPublishScheduled) return "schedule";
      if (!this.page.is_published) return "draft";
      return null;
    },
    pageStatus() {
      if (["Product Page", "Collection Page", "Home Page"].includes(this.pageType[this.page.type])) {
        if (this.isDefault()) return this.$t("generals.default");
        return;
      }
      if (this.isPublishScheduled) return this.$t("page.status.scheduled");
      if (!this.page.is_published) return this.$t("generals.draft");
      return null;
    },
    isModifiedAt() {
      return (["Product Page", "Collection Page", "Home Page"].includes(this.pageType[this.page.type]) && !this.isPublishScheduled) || (["Landing Page", "Blog Post"].includes(this.pageType[this.page.type]) && !this.isPublishScheduled);
    },
    isPublishScheduled() {
      if (!this.page.events) return false;
      return this.page.events.some(item => item.event == "schedule_publish");
    },
    schedulePublishAt() {
      if (!this.isPublishScheduled) return null;
      const scheduleEvent = this.page.events.find(item => item.event == "schedule_publish");
      const scheduledDate = new TimeMaker(scheduleEvent.event_at).ago(this.language);
      return `${this.$t("page.sort.scheduled")} ${scheduledDate}`;
    },
    isOriginalShopifyPage() {
      return this.textDefault[this.page.title] ? true : false;
    },
    thumbnail() {
      const url = this.page.thumbnailUrl;
      let fileExtension = this.getFileExtensionFromSource(url);
      if (!fileExtension || url.includes("ThumbnailPlaceholder")) {
        return require("@/core/assets/ThumbnailPlaceholder.jpg");
      }
      return `${url.slice(0, url.length - (fileExtension.length + 1))}_thumbnail.${fileExtension}`;
    },
    titlePage() {
      return this.textDefault[this.page.title] ?? this.page.title;
    },
    lastModfiedTime() {
      return new TimeMaker(this.page.updated_at).ago(this.language);
    },
    isDisabledSelect() {
      return this.isDefault();
    },
    isSelected() {
      if (this.currentPageType == "productpages") {
        return this.productList.includes(this.page.id);
      } else {
        return this.articleList.includes(this.page.id);
      }
    },
    assignmentCount() {
      const assignCount = this.page.assignmentCount ? this.page.assignmentCount : 0;
      return `Assigned ${assignCount} ${this.$tc("page.productLower", assignCount > 1 ? 2 : 1)}`;
    }
  },
  methods: {
    ...mapMutations("downgrade", {
      updateUnpublishPage: mutations.UPDATE_UNPUBLISH_PAGE_LIST
    }),
    ...mapMutations("page", {
      updateProductAssignAll: "UPDATE_ASSIGN_ALL_PRODUCT"
    }),
    layoutDefaultStatus() {
      return ["template-collection", "template-index", "template-product"].includes(this.page.type) ? true : false;
    },
    isDefault() {
      if (this.layoutDefaultStatus()) {
        return this.page.published ? true : false;
      }
    },
    checkHoverTruncateABTestDesc() {
      this.$nextTick(() => {
        if (this.$refs.ab.offsetWidth < this.$refs.ab.scrollWidth) this.campaignDescTooltip = true;
      });
    },
    getFileExtensionFromSource(src) {
      if (!src.includes(".")) return undefined;
      const lastItem = src.split(".").pop();
      if (!lastItem) return undefined;
      const extension = lastItem.split("?").shift();
      return extension;
    },
    selectPage() {
      if (this.isDisabledSelect) return;
      this.updateUnpublishPage({
        type: this.currentPageType,
        pageId: this.page.id
      });
    }
  }
};
</script>

<style lang="scss">
.recent-pages__item-unpublish {
  margin-bottom: 12px !important;
  border: none !important;
  &:hover {
    box-shadow: none !important;
  }
}

.unpublish-card__checkbox {
  width: 40px;
  height: 40px;
  @include flex-center;
}
.unpublish-card__checkbox-item {
  width: 17.5px;
  height: 17.5px;
  border: solid 1.25px $dark6;
  outline: 2px solid transparent;
  background-color: #ffffff;
  border-radius: 4px;
  padding-bottom: 0px !important;
  @include trans-all;
  @include flex-center;
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .icon:not(.icon-indeterminate) {
    height: inherit;
  }
  .icon::before {
    font-size: 10.83px;
  }
  &.checked-disabled {
    background: $neutral7;
    .icon {
      color: $light3;
    }
  }
  &:not(.checked-disabled):not(.unchecked-disabled):hover {
    border-color: $mono3;
    outline-color: rgba(26, 148, 255, 0.2);
    cursor: pointer;
  }

  &.checked {
    background: $mono3;
    border-color: $mono3;

    &:hover {
      outline-color: rgba(26, 148, 255, 0.2);
    }
  }

  &.unchecked-disabled {
    border-color: $textDarkModeHigh;
  }
}
</style>
